var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.414 3.221l.365.365L14.193 5l1.414-1.414.144-.144a.848.848 0 000-1.2L13.759.248a.848.848 0 00-1.2 0l-.145.144L11 1.807l1.414 1.414zM9.708 3L13 6.292l-9.585 9.576a.4.4 0 01-.223.124L3.107 16H.44a.434.434 0 01-.432-.36L0 15.562v-2.668c0-.093.025-.175.074-.247l.058-.07L9.708 3zm0 2.828L2 13.535V14h.454l7.716-7.71-.462-.462z",
    fill: "#8A91A5"
  })));
}
export default SvgEdit;